var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"md":"12","cols":"12","offset-md":"0"}},[_c('iframe',{staticStyle:{"position":"relative","border":"none","margin-bottom":"-7px"},style:(_vm.$vuetify.breakpoint.mdAndUp
        ? 'min-height: calc(100vh )'
        : 'min-height: calc((100vh ) / 1.8)'),attrs:{"src":"https://yandex.ru/map-widget/v1/-/CCUB6WQDLD","width":_vm.sizes.width,"allowfullscreen":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }